import type { CookieConsentConfig } from "vanilla-cookieconsent";

const getConfig = () => {
  const config: CookieConsentConfig = {
    guiOptions: {
      consentModal: {
        layout: "cloud inline",
        position: "bottom center",
        equalWeightButtons: false,
        flipButtons: true,
      },
      preferencesModal: {
        layout: "box",
        equalWeightButtons: false,
        flipButtons: true,
      },
    },
    autoClearCookies: true,
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        autoClear: {
          cookies: [
            {
              name: /^_ga/, // regex: match all cookies starting with '_ga'
            },
            {
              name: "_gid", // string: exact cookie name
            },
          ],
        },
      },
    },
    language: {
      default: "pt",
      translations: {
        en: {
          consentModal: {
            title: "We use cookies",
            description:
              "We use cookies and other tracking technologies to improve your browsing experience on our website, to analyze our website traffic, and to understand where our visitors are coming from.",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Reject all",
            showPreferencesBtn: "Manage my preferences",
          },
          preferencesModal: {
            title: "Manage cookie preferences",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Reject all",
            savePreferencesBtn: "Accept current selection",
            closeIconLabel: "Close",
            sections: [
              {
                title: "Your privacy is important to us",
                description:
                  "Cookies are very small text files that are stored on your computer when you visit a website. We use cookies for a variety of purposes and to enhance your online experience on our website. <br/><br/>You can change your preferences and decline certain types of cookies to be stored on your computer while browsing our website. You can also remove any cookies already stored on your computer.",
              },
              {
                title: "Performance and Analytics",
                description:
                  "These cookies are used to collect information to analyze the traffic to our website and how visitors are using our website. For example, these cookies may track things such as how long you spend on the website or the pages you visit which helps us to understand how we can improve our website for you. <br/><br/>The information collected through these tracking and performance cookies do not identify any individual visitor.",
                linkedCategory: "analytics",
                cookieTable: {
                  headers: {
                    name: "Name",
                    domain: "Service",
                    description: "Description",
                    expiration: "Expiration",
                  },
                  body: [
                    
                    {
                      name: "_ga",
                      domain: "Google Analytics",
                      description: "Cookie set by Google Analytics",
                      expiration: "Expires after 35 days",
                    },
                    {
                      name: "_gid",
                      domain: "Google Analytics",
                      description: "Cookie set by Google Analytics",
                      expiration: "Session",
                    }
                  ]
                }
              },
              {
                title: "Targeting and advertising cookies",
                description: "These cookies are used to show advertising that is likely to be of interest to you based on your browsing habits. <br/><br/>These cookies, as served by our content and/or advertising providers, may combine information they collected from our website with other information they have independently collected relating to your web browser's activities across their network of websites. <br/><br/>If you choose to remove or disable these targeting or advertising cookies, you will still see adverts but they may not be relevant to you."
              },
              {
                title: "More information",
                description:
                  "For any queries in relation to our policy on cookies and your choices, please contact us.",
              },
            ],
          },
        },
        pt: {
          consentModal: {
            title: "O nosso site usa cookies",
            description:
              "Utilizamos cookies e outras tecnologias de medição para melhorar a sua experiência de navegação no nosso site, analisar o tráfego do site e entender de onde vêm os visitantes.",
            acceptAllBtn: "Aceitar todos",
            acceptNecessaryBtn: "Rejeitar todos",
            showPreferencesBtn: "Alterar as minhas preferências",
          },
          preferencesModal: {
            title: "Centro de preferências de cookies",
            acceptAllBtn: "Aceitar todos",
            acceptNecessaryBtn: "Rejeitar todos",
            savePreferencesBtn: "Guardar as minhas preferências",
            closeIconLabel: "Fechar",
            sections: [
              {
                title: "A sua privacidade é importante para nós",
                description:
                  "Cookies são pequenos arquivos de texto que são armazenados no seu computador quando visita um site. Utilizamos cookies para diversos fins e para aprimorar sua experiência no nosso site. <br/><br/>Pode alterar as suas preferências e recusar o armazenamento de certos tipos de cookies no seu computador enquanto navega no nosso site. Pode também remover todos os cookies já armazenados no seu computador.",
              },
              {
                title: "Cookies estritamente necessários",
                description:
                  "Estes cookies são essenciais para o funcionamento correcto do nosso website e não podem ser desactivados.",
                linkedCategory: "necessary",
              },
              {
                title: "Cookies de medição e desempenho",
                description:
                  "Estes cookies são usados ​​para coletar informações para analisar o tráfego no nosso site e entender como é que os visitantes estão a usar o nosso site. Por exemplo, estes cookies podem medir fatores como o tempo despendido no site ou as páginas visitadas, isto vai permitir entender como podemos melhorar o nosso site para os utilizadores. <br/><br/>As informações coletadas por meio destes cookies de medição e desempenho não identificam nenhum visitante individual.",
                linkedCategory: "analytics",
                cookieTable: {
                  headers: {
                    name: "Nome",
                    domain: "Serviço",
                    description: "Descrição",
                    expiration: "Expiração",
                  },
                  body: [
                    {
                      name: "_ga",
                      domain: "Google Analytics",
                      description: "Cookie criado por Google Analytics",
                      expiration: "Expira após 35 dias",
                    },
                    {
                      name: "_gid",
                      domain: "Google Analytics",
                      description: "Cookie criado por Google Analytics",
                      expiration: "Sessão",
                    }
                  ]
                }
              },
              {
                title: "Cookies de segmentação e publicidade",
                description: "Estes cookies são usados ​​para mostrar publicidade que provavelmente lhe pode interessar com base nos seus hábitos e comportamentos de navegação. <br/><br/>Estes cookies, servidos pelo nosso conteúdo e/ ou fornecedores de publicidade, podem combinar as informações coletadas no nosso site com outras informações coletadas independentemente relacionadas com as atividades na rede de sites do seu navegador. <br/><br/>Se optar por remover ou desativar estes cookies de segmentação ou publicidade, ainda verá anúncios, mas estes poderão não ser relevantes para si."
              },
              {
                title: "Mais informação",
                description:
                  "Para qualquer dúvida sobre a nossa política de cookies e as suas opções, entre em contato connosco.",
              },
            ],
          },
        },
      },
    },
  };
  return config;
};

export { getConfig };
